import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Form, Input, InputNumber } from 'antd';
import ReactTable from '../general/form-control/react-table';
import { numberWithCommas } from '../general/convertor';
import moment from 'moment';
import EditUnrealizePriceMdal from './EditUnrealizedPriceModal';
import api from '../../apis';
import { usePagination } from '../tables/helper';
import { getStock } from '../../apis/feedProvider';
import property from '../../constants/property';

const PortfolioUnrealizedHistoryModal = ({
    children,
    data,
    onModalClose,
    canEditPrice = true
}:any) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const [_inputs, _setInputs] = useState({});
  const { tablePagination, setTablePagination } = usePagination();


    useEffect(() => {

        setInitialValues(data)
    }, []);

  // Function to show the modal
  const showModal = () => {
    setIsModalVisible(true);
    //console.log('Received values:', initialValues);

    requestTableData(1,_inputs);
  };

  // Function to hide the modal
  const handleOk = () => {
    setIsModalVisible(false);
  };

  // Function to hide the modal on cancel
  const handleCancel = () => {
    setIsModalVisible(false);
    onModalClose();
  };



  const requestTableData = async (cPage=1,inputs:any={}) =>{
    // if(accounts.length <1) {
    //     setTableData([])
    //     return 
    // }

    setTableData([]);

    let aid = initialValues.aid;
    let tid = initialValues.tid;
   // if(!orderNo)return;
    setLoading(true)
    let result = await api.getPortfolioUnrealizedHistory(aid,tid, inputs,cPage);
    //console.log("getPortfolioUnRealized history result ",result)
    if(result.history){
        setTableData(result.history)
    }

    
    if (result.total) {
        // handlePagination('currentPage', cPage);
        // handlePagination('totalRecords', result.total);
        setTablePagination({
            currentPage: cPage,
            totalRecords: result.total
        });
    }

    setLoading(false)
   // console.log("getTradeHistoryLogs",result)
}




  const tblColumns =  [
    {
        Header: 'Ref Number',
        accessor: 'orderno',
       
    },
    {
        Header: 'Date',
        accessor: 'tradetime',
        Cell: (v: any) => {
          if (v.value){
              const formattedDate1 = moment(v.value).format('YYYY-MM-DD');
              const formattedTime = moment(v.value).format('HH:mm:ss');
              return <div style={{width:"max-content"}}><div>{formattedDate1} {formattedTime}</div></div>;
          }
              
      }
    },
    {
        Header: 'Transaction Type',
        accessor: 'action_name',
        
    },
    {
        Header: 'Quantity',
        accessor: 'qty',
        Cell: (v: any) => {
          if (v.value)
              return (
                  <div className="text-right">
                      {numberWithCommas(v.value)}
                  </div>
              );
      }
    },
    {
        Header: 'Price',
        accessor: 'price',
        Cell: (v: any) => {
            let row = v.row.original;

            let changePriceAction = property.mapChgPriceAction

            if(!changePriceAction[row.action] ||  canEditPrice == false){
              return <div className="text-right" >{numberWithCommas(v.value,3)}</div>
            }


            // if(row.action !== 2 && row.action !== 3){
            //   return <div className="text-right" >{numberWithCommas(v.value,3)}</div>
            // }

            let aid = initialValues.aid;
            let tid = initialValues.tid;

            //trade in/out
            if (v.value && canEditPrice == true)
                return (
                    <div className="text-right" >
                        <EditUnrealizePriceMdal data={row} aid={aid} tid={tid} onClose={()=>{
                          requestTableData(1,_inputs);
                        }}>
                          <u className='cursor-pointer'>{numberWithCommas(v.value,3)}</u>
                        </EditUnrealizePriceMdal>
                    </div>
                );
        }
    },

]


  return (
    <div>

      <span onClick={showModal}  >
        <u className='cursor-pointer'>
        {
            children
        }

        </u>
      </span>

      <Modal
        title="History"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        width={"90vw"}
        style={{ maxWidth: '1200px' }} 
      >
        <ReactTable
                headerStyle={{
                    background: 'rgba(210, 209, 209, 1)',
                    color:"black"
                }}
                columns={tblColumns}
              //   data={[{
              //       ref:"60654397",
              //       date:"15/07/2024",
              //       type:"buy",
              //       qty:1900,
              //       mkt_price:0.085
              //   },
              //   {
              //     ref:"70654397",
              //     date:"16/07/2024",
              //     type:"transfer in/out",
              //     qty:1000,
              //     mkt_price:1.000
              // }]}
              data={tableData}
                pageSize={10}
                loading={loading}
                size='small'
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) =>
                  requestTableData( cPage,_inputs)
                }
                hasPagination
            />
      </Modal>
    </div>
  );
};

export default PortfolioUnrealizedHistoryModal;